import * as React from 'react';
import { api } from '@/lib/api-client';

/**
 * Whether the sign-up page is open: only while the CRM has no organization.
 *
 * `checked` is false until the server has answered, so a page can wait rather
 * than flash a link that is about to vanish. An unreachable API counts as
 * closed — the sign-in form already reports that problem on its own.
 */
export function useRegistrationOpen(): { open: boolean; checked: boolean } {
  const [open, setOpen] = React.useState(false);
  const [checked, setChecked] = React.useState(false);

  React.useEffect(() => {
    const controller = new AbortController();
    api
      .get<{ open: boolean }>('/auth/registration', controller.signal)
      .then((status) => setOpen(status.open))
      .catch(() => setOpen(false))
      .finally(() => setChecked(true));
    return () => controller.abort();
  }, []);

  return { open, checked };
}
